import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import { Row, Col, Tag, Skeleton, Modal, message } from 'antd'
import { connect } from 'react-redux'
import { ButtonItem } from '../../../../Components/Items'
import DatePickerItem from '../../../../Components/DatePickerItem'
import { ExclamationCircleOutlined } from '@ant-design/icons'

// ─── Helpers ──────────────────────────────────────────────────────────────────

const fmtMXN = (n) =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n || 0)

const fmtFecha = (f) => {
  if (!f) return '—'
  const s = (f || '').split('T')[0]
  const p = s.split('-')
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s
}

const TIPO_CONCEPTO_LABEL = { percepcion: 'Percepción', deduccion: 'Deducción' }
const TIPO_VALOR_LABEL    = { importe: 'Importe $',    valor: 'Valor'          }

// Mapeo string → número que espera el endpoint selectConceptosNomina
const TIPO_CONCEPTO_NUM   = { percepcion: 1, deduccion: 2 }

// ─── Estilos tabla ────────────────────────────────────────────────────────────

const TH = {
  border: '1px solid #d0d0d0', background: '#f5f5f5',
  padding: '5px 8px', fontSize: 11, fontWeight: 600,
  color: '#555', textAlign: 'center', whiteSpace: 'nowrap',
}
const TD = {
  border: '1px solid #e8e8e8', padding: '4px 8px',
  fontSize: 12, verticalAlign: 'middle',
}
const TD_NUM = { ...TD, textAlign: 'right', fontFamily: 'monospace' }

// ─── Estilos formulario ───────────────────────────────────────────────────────

const labelStyle   = { display: 'block', fontSize: 11, color: '#888', marginBottom: 3 }
const inputStyle   = { width: '100%', padding: '4px 8px', border: '1px solid #d0d0d0', borderRadius: 4, fontSize: 12, boxSizing: 'border-box' }
const selectStyle  = { ...inputStyle, background: 'white', cursor: 'pointer', height: 28 }
const btnSmallStyle = { fontSize: 11, padding: '2px 8px', borderRadius: 4, border: '1px solid', cursor: 'pointer', background: 'white' }

// ─────────────────────────────────────────────────────────────────────────────

class MovimientosPermanentesEmpleado extends Component {

  state = {
    cargando: false,
    error: null,
    movimientos: [],
    todosConceptos: [],
    // Formulario
    formVisible: false,
    editandoId: null,
    descripcion: '',
    tipoConcepto: 'deduccion',
    conceptoId: '',
    fechaInicio: '',
    tipoValor: 'importe',
    importe: 0,
    vecesAplicar: 0,
    montoLimite: 0,
    numeroControl: '',
    montoAcumulado: '',
    vecesAplicado: '',
    guardando: false,
    errorConceptoDuplicado: null,
    // Historial
    historialVisible: false,
    historialMovimiento: null,
  }

  verHistorial(mov) {
    this.setState({ historialVisible: true, historialMovimiento: mov })
  }

  cerrarHistorial() {
    this.setState({ historialVisible: false, historialMovimiento: null })
  }

  renderModalHistorial() {
    const { historialVisible, historialMovimiento } = this.state
    const bitacora = historialMovimiento?.bitacoraAplicaciones || []

    return (
      <Modal
        title={`Historial — ${historialMovimiento?.descripcion || ''}`}
        visible={historialVisible}
        onCancel={() => this.cerrarHistorial()}
        footer={null}
        width={560}
      >
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={TH}>Fecha</th>
                <th style={{ ...TH, textAlign: 'right' }}>Importe Aplicado</th>
                <th style={{ ...TH, textAlign: 'right' }}>Acumulado</th>
                <th style={TH}>Liquidado</th>
              </tr>
            </thead>
            <tbody>
              {bitacora.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ ...TD, textAlign: 'center', color: '#aaa', padding: 24 }}>
                    Sin movimientos registrados todavía
                  </td>
                </tr>
              )}
              {bitacora.map((mov, i) => (
                <tr key={i}>
                  <td style={TD}>{(mov.fecha + '').split('T')[0].split('-').reverse().join('/')}</td>
                  <td style={TD_NUM}>{fmtMXN(mov.importeAplicado)}</td>
                  <td style={TD_NUM}>{fmtMXN(mov.montoAcumuladoResultante)}</td>
                  <td style={{ ...TD, textAlign: 'center' }}>{mov.liquidado ? '✓' : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    )
  }

  componentDidMount() {
    this.cargarDatos()
    this.cargarTodosConceptos()
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.empleadoId !== this.props.empleadoId ||
      prevProps.empresaId  !== this.props.empresaId
    ) {
      this.resetForm()
      this.cargarDatos()
    }
    if (prevProps.empresaId !== this.props.empresaId) {
      this.cargarTodosConceptos()
    }
    // Resetear concepto seleccionado cuando cambia el tipo
    if (prevState.tipoConcepto !== this.state.tipoConcepto && this.state.formVisible) {
      this.setState({ conceptoId: '', errorConceptoDuplicado: null })
    }
  }

  resetForm() {
    this.setState({
      formVisible: false, editandoId: null,
      descripcion: '', tipoConcepto: 'deduccion', conceptoId: '',
      fechaInicio: '', tipoValor: 'importe', importe: 0,
      vecesAplicar: 0, montoLimite: 0, numeroControl: '',
      montoAcumulado: '', vecesAplicado: '',
      errorConceptoDuplicado: null,
    })
  }

  // ── Fetch ──────────────────────────────────────────────────────────────────

  async cargarTodosConceptos() {
    const { empresaId, headersToken } = this.props
    if (!empresaId) return
    try {
      const res = await axios.post(
        'conceptosNomina/selectAllConceptosNomina',
        { empresaId },
        { headers: headersToken }
      )
      if (res.data.success === 2) {
        this.setState({
          todosConceptos: res.data.conceptosNomina || res.data.data || [],
        })
      }
    } catch { /* silent — el <select> quedará vacío */ }
  }

  async cargarDatos() {
    const { empleadoId, empresaId, headersToken } = this.props
    if (!empleadoId || !empresaId) return
    this.setState({ cargando: true, error: null })
    try {
      const res = await axios.post(
        'nomina/movimientosPermanentes',
        { empleadoId, empresaId },
        { headers: headersToken }
      )
      if (res.data.success === 2) {
        this.setState({ movimientos: res.data.movimientos || [] })
      } else {
        this.setState({ error: res.data.err || res.data.mensaje || 'Error al cargar movimientos permanentes' })
      }
    } catch {
      this.setState({ error: 'Error de conexión' })
    }
    this.setState({ cargando: false })
  }

  // ── Acciones ───────────────────────────────────────────────────────────────

  confirmarInactivar(movimientoId) {
    Modal.confirm({
      title: '¿Inactivar este movimiento permanente?',
      content: 'Ya no se aplicará en futuros períodos.',
      icon: <ExclamationCircleOutlined />,
      okText: 'Sí, inactivar',
      cancelText: 'No',
      onOk: () => this.inactivarMovimiento(movimientoId),
    })
  }

  async inactivarMovimiento(movimientoId) {
    const { empresaId, headersToken } = this.props
    try {
      const res = await axios.post(
        'nomina/cancelarMovimientoPermanente',
        { movimientoId, empresaId },
        { headers: headersToken }
      )
      if (res.data.success === 2) {
        message.success('Movimiento inactivado')
        this.cargarDatos()
        this.props.onCambio?.()
      } else {
        message.error(res.data.err || res.data.mensaje || 'Error al inactivar')
      }
    } catch {
      message.error('Error de conexión')
    }
  }

  abrirEdicion(mov) {
    this.setState({
      formVisible: true,
      editandoId: mov._id,
      descripcion: mov.descripcion || '',
      tipoConcepto: mov.tipoConcepto || 'deduccion',
      conceptoId: mov.conceptoId?._id || mov.conceptoId || '',
      fechaInicio: (mov.fechaInicio || '').split('T')[0],
      tipoValor: mov.tipoValor || 'importe',
      importe: mov.importe || 0,
      vecesAplicar: mov.vecesAplicar || 0,
      montoLimite: mov.montoLimite || 0,
      numeroControl: mov.numeroControl || '',
      errorConceptoDuplicado: null,
    })
  }

  abrirFormularioNuevo() {
    this.setState({
      formVisible: true, editandoId: null,
      descripcion: '', tipoConcepto: 'deduccion', conceptoId: '',
      fechaInicio: '', tipoValor: 'importe', importe: 0,
      vecesAplicar: 0, montoLimite: 0, numeroControl: '',
      montoAcumulado: '', vecesAplicado: '',
      errorConceptoDuplicado: null,
    })
  }

  validarConceptoDuplicado(conceptoId) {
    const { editandoId, movimientos } = this.state
    if (!conceptoId) return null
    const duplicado = movimientos.find(m =>
      m.estatus === 1 &&
      (m.conceptoId?._id || m.conceptoId) === conceptoId &&
      m._id !== editandoId
    )
    return duplicado ? 'Este concepto ya tiene un movimiento permanente activo' : null
  }

  async guardarMovimiento() {
    const { empleadoId, empresaId, headersToken } = this.props
    const {
      descripcion, tipoConcepto, conceptoId, fechaInicio, tipoValor,
      importe, vecesAplicar, montoLimite, numeroControl, editandoId,
      montoAcumulado, vecesAplicado,
    } = this.state

    if (!descripcion.trim())    { message.error('Ingresa una descripción');                  return }
    if (!conceptoId)            { message.error('Selecciona un concepto');                   return }
    if (!fechaInicio)           { message.error('Ingresa la fecha de inicio');               return }
    if (!(parseFloat(importe) > 0)) { message.error('Ingresa un importe o valor mayor a 0'); return }

    const errDuplicado = this.validarConceptoDuplicado(conceptoId)
    if (errDuplicado) { this.setState({ errorConceptoDuplicado: errDuplicado }); return }

    const body = {
      movimientoId: editandoId || undefined,
      empleadoId, empresaId,
      conceptoId,
      descripcion: descripcion.trim(),
      tipoConcepto, fechaInicio, tipoValor,
      importe:      parseFloat(importe)     || 0,
      vecesAplicar: parseInt(vecesAplicar)  || 0,
      montoLimite:  parseFloat(montoLimite) || 0,
      numeroControl: numeroControl.trim(),
    }
    if (!editandoId) {
      body.montoAcumulado = parseFloat(montoAcumulado) || 0
      body.vecesAplicado  = parseInt(vecesAplicado, 10) || 0
    }

    this.setState({ guardando: true })
    try {
      const endpoint = editandoId
        ? 'nomina/editarMovimientoPermanente'
        : 'nomina/crearMovimientoPermanente'
      const res = await axios.post(endpoint, body, { headers: headersToken })
      if (res.data.success === 2) {
        message.success(editandoId ? 'Movimiento actualizado' : 'Movimiento registrado')
        this.resetForm()
        this.cargarDatos()
        this.props.onCambio?.()
      } else {
        message.error(res.data.err || res.data.mensaje || 'Error al guardar')
      }
    } catch {
      message.error('Error de conexión')
    }
    this.setState({ guardando: false })
  }

  // ── Helpers ────────────────────────────────────────────────────────────────

  getTextoAplicacion() {
    const v = parseInt(this.state.vecesAplicar) || 0
    const m = parseFloat(this.state.montoLimite) || 0
    if (v === 0 && m === 0)
      return { text: 'ℹ Se aplicará indefinidamente en cada período', color: '#1677ff' }
    if (v > 0 && m === 0)
      return { text: `Se aplicará ${v} veces`, color: '#888' }
    if (v === 0 && m > 0)
      return { text: `Se aplicará hasta acumular ${fmtMXN(m)}`, color: '#888' }
    return {
      text: `Se completará al llegar a ${v} veces o ${fmtMXN(m)}, lo que ocurra primero`,
      color: '#888',
    }
  }

  getConceptoLabel(mov) {
    const c = mov.conceptoId
    if (!c) return '—'
    if (typeof c === 'object') return `${c.numero} - ${c.descripcion}`
    return c
  }

  // ── Renders ────────────────────────────────────────────────────────────────

  renderCards() {
    const { movimientos } = this.state
    const activos     = movimientos.filter(m => m.estatus === 1).length
    const inactivos   = movimientos.filter(m => m.estatus === 0).length
    const completados = movimientos.filter(m => m.estatus === 2).length

    return (
      <Row gutter={12} style={{ marginBottom: 16 }}>
        <Col span={8}>
          <div style={{ background: '#f6ffed', borderRadius: 6, padding: '10px 14px' }}>
            <div style={{ fontSize: 11, color: '#3B6D11' }}>Activos</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#3B6D11' }}>{activos}</div>
          </div>
        </Col>
        <Col span={8}>
          <div style={{ background: '#f5f5f5', borderRadius: 6, padding: '10px 14px' }}>
            <div style={{ fontSize: 11, color: '#595959' }}>Inactivos</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#595959' }}>{inactivos}</div>
          </div>
        </Col>
        <Col span={8}>
          <div style={{ background: '#e6f4ff', borderRadius: 6, padding: '10px 14px' }}>
            <div style={{ fontSize: 11, color: '#1677ff' }}>Completados</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#1677ff' }}>{completados}</div>
          </div>
        </Col>
      </Row>
    )
  }

  renderTabla() {
    const { movimientos } = this.state
    const { timbrado } = this.props

    const colCount = timbrado ? 12 : 13

    return (
      <div style={{ overflowX: 'auto' }}>
        <table style={{ borderCollapse: 'collapse', tableLayout: 'auto', minWidth: 900 }}>
          <thead>
            <tr>
              <th style={{ ...TH, minWidth: 130 }}>Descripción</th>
              <th style={TH}>Tipo</th>
              <th style={{ ...TH, minWidth: 160 }}>Concepto</th>
              <th style={TH}>Tipo Valor</th>
              <th style={TH}>Importe</th>
              <th style={TH}>V. Aplicar</th>
              <th style={TH}>V. Aplicado</th>
              <th style={TH}>M. Límite</th>
              <th style={TH}>M. Acumulado</th>
              <th style={TH}>Fecha Inicio</th>
              <th style={TH}>No. Control</th>
              <th style={TH}>Estatus</th>
              {!timbrado && <th style={TH}>Acciones</th>}
            </tr>
          </thead>
          <tbody>
            {movimientos.length === 0 && (
              <tr>
                <td colSpan={colCount} style={{ ...TD, textAlign: 'center', color: '#aaa', padding: 24 }}>
                  Sin movimientos permanentes registrados
                </td>
              </tr>
            )}
            {movimientos.map(mov => {
              const activo    = mov.estatus === 1
              const inactivo  = mov.estatus === 0
              const completado = mov.estatus === 2
              const esEditable = activo && !timbrado

              const rowBg    = inactivo ? '#f5f5f5' : completado ? '#f0f5ff' : 'white'
              const textStyle = inactivo ? { textDecoration: 'line-through', color: '#aaa' } : {}

              return (
                <tr key={mov._id} style={{ background: rowBg }}>
                  <td style={{ ...TD, ...textStyle, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {mov.descripcion}
                  </td>
                  <td style={{ ...TD, ...textStyle }}>
                    {TIPO_CONCEPTO_LABEL[mov.tipoConcepto] || mov.tipoConcepto}
                  </td>
                  <td style={{ ...TD, ...textStyle, maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {this.getConceptoLabel(mov)}
                  </td>
                  <td style={{ ...TD, ...textStyle }}>
                    {TIPO_VALOR_LABEL[mov.tipoValor] || mov.tipoValor}
                  </td>
                  <td style={{ ...TD_NUM, ...textStyle }}>{fmtMXN(mov.importe)}</td>
                  <td style={{ ...TD_NUM, ...textStyle }}>
                    {mov.vecesAplicar === 0 ? '∞' : mov.vecesAplicar}
                  </td>
                  <td style={{ ...TD_NUM, ...textStyle }}>{mov.vecesAplicado ?? 0}</td>
                  <td style={{ ...TD_NUM, ...textStyle }}>
                    {!mov.montoLimite ? '—' : fmtMXN(mov.montoLimite)}
                  </td>
                  <td style={{ ...TD_NUM, ...textStyle }}>{fmtMXN(mov.montoAcumulado)}</td>
                  <td style={{ ...TD, ...textStyle }}>{fmtFecha(mov.fechaInicio)}</td>
                  <td style={{ ...TD, ...textStyle }}>{mov.numeroControl || '—'}</td>
                  <td style={{ ...TD, textAlign: 'center' }}>
                    {inactivo   && <Tag color="default" style={{ color: '#aaa' }}>Inactivo</Tag>}
                    {completado && <Tag color="blue">Completado</Tag>}
                    {activo     && <Tag color="green">Activo</Tag>}
                  </td>
                  {!timbrado && (
                    <td style={{ ...TD, textAlign: 'center', whiteSpace: 'nowrap' }}>
                      <button type="button"
                        onClick={() => this.verHistorial(mov)}
                        style={{ ...btnSmallStyle, color: '#555', borderColor: '#555' }}
                      >
                        Historial
                      </button>
                      {' '}
                      {esEditable && (
                        <>
                          <button type="button"
                            onClick={() => this.abrirEdicion(mov)}
                            style={{ ...btnSmallStyle, color: '#1677ff', borderColor: '#1677ff' }}
                          >
                            Editar
                          </button>
                          {' '}
                          <button type="button"
                            onClick={() => this.confirmarInactivar(mov._id)}
                            style={{ ...btnSmallStyle, color: '#ff4d4f', borderColor: '#ff4d4f' }}
                          >
                            Inactivar
                          </button>
                        </>
                      )}
                    </td>
                  )}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }

  renderFormulario() {
    const {
      descripcion, tipoConcepto, conceptoId, fechaInicio, tipoValor,
      importe, vecesAplicar, montoLimite, numeroControl,
      editandoId, guardando, errorConceptoDuplicado,
      montoAcumulado, vecesAplicado, movimientos,
    } = this.state

    const { text: textoAyuda, color: colorAyuda } = this.getTextoAplicacion()
    const importeLabel = tipoValor === 'importe' ? 'Monto $' : 'Valor (días/unidades)'
    const movEditando = editandoId ? movimientos.find(m => m._id === editandoId) : null

    return (
      <div style={{ border: '1px solid #d0d0d0', borderRadius: 6, padding: 16, marginBottom: 16, background: '#fafcff' }}>
        <div style={{ fontWeight: 600, marginBottom: 12, color: '#555', fontSize: 13 }}>
          {editandoId ? 'Editar movimiento permanente' : 'Nuevo movimiento permanente'}
        </div>

        {/* Descripción */}
        <div style={{ marginBottom: 12 }}>
          <label style={labelStyle}>Descripción</label>
          <input
            type="text"
            value={descripcion}
            placeholder="Ej. Préstamo caja chica"
            onChange={e => this.setState({ descripcion: e.target.value })}
            style={inputStyle}
          />
        </div>

        {/* Tipo concepto + Concepto */}
        <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Tipo de concepto</label>
            <select
              value={tipoConcepto}
              onChange={e => this.setState({ tipoConcepto: e.target.value })}
              style={selectStyle}
            >
              <option value="percepcion">Percepción</option>
              <option value="deduccion">Deducción</option>
            </select>
          </div>
          <div style={{ flex: 2 }}>
            <label style={labelStyle}>Concepto</label>
            <select
              value={conceptoId}
              onChange={e => {
                const val = e.target.value
                this.setState({
                  conceptoId: val,
                  errorConceptoDuplicado: this.validarConceptoDuplicado(val),
                })
              }}
              style={selectStyle}
            >
              <option value="">— Seleccionar —</option>
              {this.state.todosConceptos
                .filter(c => c.tipo === TIPO_CONCEPTO_NUM[tipoConcepto])
                .map(c => (
                  <option key={c._id} value={c._id}>
                    {c.serieNumero + ' - ' + c.descripcion}
                  </option>
                ))
              }
            </select>
            {errorConceptoDuplicado && (
              <div style={{ color: '#A32D2D', fontSize: 11, marginTop: 3 }}>
                {errorConceptoDuplicado}
              </div>
            )}
          </div>
        </div>

        {/* Fecha inicio + Número control */}
        <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Fecha inicio de aplicación</label>
            <DatePickerItem
              value={fechaInicio ? moment(fechaInicio, 'YYYY-MM-DD') : null}
              onChange={(d) => this.setState({ fechaInicio: d ? d.format('YYYY-MM-DD') : '' })}
              style={{ ...inputStyle, width: '100%' }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Número de control (opcional)</label>
            <input
              type="text"
              value={numeroControl}
              placeholder="Ej. PC-001"
              onChange={e => this.setState({ numeroControl: e.target.value })}
              style={inputStyle}
            />
          </div>
        </div>

        {/* Tipo valor + Importe */}
        <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Tipo valor</label>
            <select
              value={tipoValor}
              onChange={e => this.setState({ tipoValor: e.target.value })}
              style={selectStyle}
            >
              <option value="importe">Importe (monto fijo $)</option>
              <option value="valor">Valor (días/unidades)</option>
            </select>
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>{importeLabel}</label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={importe}
              onChange={e => this.setState({ importe: e.target.value })}
              style={inputStyle}
            />
          </div>
        </div>

        {/* Veces aplicar + Monto límite */}
        <div style={{ marginBottom: 12 }}>
          <div style={{ display: 'flex', gap: 12, marginBottom: 4 }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Veces a aplicar (0 = indefinido)</label>
              <input
                type="number"
                min="0"
                step="1"
                value={vecesAplicar}
                onChange={e => this.setState({ vecesAplicar: e.target.value })}
                style={inputStyle}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Monto límite (0 = sin límite)</label>
              <input
                type="number"
                min="0"
                step="0.01"
                value={montoLimite}
                onChange={e => this.setState({ montoLimite: e.target.value })}
                style={inputStyle}
              />
            </div>
          </div>
          <div style={{ fontSize: 11, color: colorAyuda }}>{textoAyuda}</div>
        </div>

        {/* Monto acumulado y veces aplicado (semilla inicial / solo lectura al editar) */}
        <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>
              Monto acumulado{!editandoId ? ' (inicial)' : ''}
            </label>
            {editandoId && movEditando ? (
              <input
                style={{ ...inputStyle, background: '#f5f5f5', color: '#888' }}
                value={fmtMXN(movEditando.montoAcumulado)}
                readOnly
              />
            ) : (
              <input
                type="number"
                step="0.01"
                min="0"
                style={inputStyle}
                value={montoAcumulado}
                onChange={e => this.setState({ montoAcumulado: e.target.value })}
                placeholder="0.00"
              />
            )}
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>
              Veces aplicado{!editandoId ? ' (inicial)' : ''}
            </label>
            {editandoId && movEditando ? (
              <input
                style={{ ...inputStyle, background: '#f5f5f5', color: '#888' }}
                value={movEditando.vecesAplicado || 0}
                readOnly
              />
            ) : (
              <input
                type="number"
                step="1"
                min="0"
                style={inputStyle}
                value={vecesAplicado}
                onChange={e => this.setState({ vecesAplicado: e.target.value })}
                placeholder="0"
              />
            )}
          </div>
        </div>

        {/* Botones */}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
          <ButtonItem size="small" onClick={() => this.resetForm()}>
            Cancelar captura
          </ButtonItem>
          <ButtonItem type="primary" size="small" loading={guardando} onClick={() => this.guardarMovimiento()}>
            Guardar
          </ButtonItem>
        </div>
      </div>
    )
  }

  render() {
    const { cargando, error, formVisible } = this.state
    const { timbrado, readOnly } = this.props

    if (cargando) return <Skeleton active paragraph={{ rows: 4 }} />

    if (error) {
      return (
        <div style={{ color: '#A32D2D', padding: '10px 14px', background: '#fff1f0', borderRadius: 4, fontSize: 12 }}>
          {error}
        </div>
      )
    }

    const puedeEditar = !readOnly && !timbrado

    return (
      <div>
        {timbrado && (
          <div style={{ marginBottom: 12, padding: '7px 14px', background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 6, fontSize: 12, color: '#7c5a00' }}>
            Nómina timbrada — visualización de solo lectura.
          </div>
        )}

        {this.renderCards()}

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <div style={{ fontWeight: 600, fontSize: 13, color: '#555' }}>Movimientos permanentes</div>
          {puedeEditar && !formVisible && (
            <ButtonItem size="small" type="primary" onClick={() => this.abrirFormularioNuevo()}>
              + Agregar movimiento
            </ButtonItem>
          )}
        </div>

        {formVisible && this.renderFormulario()}
        {this.renderTabla()}
        {this.renderModalHistorial()}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
})

export default connect(mapStateToProps)(MovimientosPermanentesEmpleado)
